// src/jira/filter/types.ts
var JiraFilterAriResourceOwner = "jira", JiraFilterAriResourceType = "filter";

export {
  JiraFilterAriResourceOwner,
  JiraFilterAriResourceType
};
